import { RouteConfig } from '../types';
import { ONBOARDING_KEYS } from '../constants';

export const sitesPageSteps = [
  {
    element: '[data-onboarding="sites-page"]',
    popover: {
      title: 'Sites Dashboard',
      description:
        'A site is a physical location where devices are installed and monitored. Use this page to search, add sites, and filter by key details.',
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="sites-add-button"]',
    popover: {
      title: 'Add Site',
      description:
        'Create a new site. Follow the form to add its name, location, customer, and settings.',
      side: 'bottom' as const,
      align: 'end' as const,
    },
  },
  {
    element: '[data-onboarding="sites-utility-bar"]',
    popover: {
      title: 'Search and Filter Tools',
      description:
        'Use the search bar to find sites by name. Customize your view with column visibility and open the filters panel to filter by arming status, Quill automation level, and more.',
      side: 'bottom' as const,
      align: 'center' as const,
    },
  },
  {
    element: '[data-onboarding="sites-table"] table tbody, [data-onboarding="sites-table"] table',
    popover: {
      title: 'Sites Table',
      description:
        'All sites that match your filters and search are listed here. Click a site name to view details, change settings, and manage devices.',
      side: 'top' as const,
      align: 'start' as const,
    },
  },
];

export const addSiteSteps = [
  // {
  //   element: '[data-onboarding="site-add-header"]',
  //   popover: {
  //     title: 'Add New Site',
  //     description:
  //       'Use this page to create a new site. Work through each section to set details, AI automation, sirens, and guard response.',
  //     side: 'bottom' as const,
  //     align: 'start' as const,
  //   },
  // },
  // {
  //   element: '[data-onboarding="site-add-tabs"]',
  //   popover: {
  //     title: 'Navigation Sidebar',
  //     description:
  //       'Use this sidebar to move between site configuration sections. Each section covers one part of the setup.',
  //     side: 'right' as const,
  //     align: 'start' as const,
  //   },
  // },
  // Site Details Section
  // {
  //   element: '[data-onboarding="site-add-details-section"]',
  //   popover: {
  //     title: 'Site Details',
  //     description:
  //       'Set the core site details: customer, name, location, and timezone. These fields are used everywhere the site appears in Watchful.',
  //     side: 'left' as const,
  //     align: 'start' as const,
  //   },
  // },
  {
    element: '[data-onboarding="site-add-customer-select"]',
    popover: {
      title: 'Select Customer',
      description:
        'Choose which customer this site belongs to. You can search by name. This links the site to the customer’s account.',
      side: 'left' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="site-add-name"]',
    popover: {
      title: 'Site Name',
      description:
        'Enter a clear, descriptive site name. It will appear in alerts, reports, and device management screens.',
      side: 'left' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="site-add-address"]',
    popover: {
      title: 'Site Location',
      description:
        'Set the site location by searching for an address or entering coordinates. You can also adjust the location on the map. The timezone will be automatically detected based on the location.',
      side: 'left' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="site-add-save"]',
    popover: {
      title: 'Save Site',
      description:
        'Select Save when required fields are complete. You can add devices and adjust settings after saving.',
      side: 'top' as const,
      align: 'end' as const,
    },
  },
];

export const siteDetailSteps = [
  {
    element: '[data-onboarding="site-detail-header"]',
    popover: {
      title: 'Site Details',
      description:
        'The header displays the site name, and key stats such as devices, zones, and arm status. The badge shows whether the site is Armed, Disarmed, or in Test Mode.',
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="site-detail-actions"]',
    popover: {
      title: 'Site Actions',
      description:
        'Extra actions, such as archiving or deleting the site. Use these options to manage the site lifecycle.',
      side: 'left' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="site-detail-save"]',
    popover: {
      title: 'Save Changes',
      description:
        'Save updates to the site before leaving the page.',
      side: 'bottom' as const,
      align: 'end' as const,
    },
  },
  {
    element: '[data-onboarding="site-detail-tabs"]',
    popover: {
      title: 'Site Tabs',
      description:
        'Use these tabs to move between site sections, such as Site Details, Alerts, Components, Devices, and Logs.',
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="site-detail-content"]',
    popover: {
      title: 'Content Area',
      description:
        'Content for the selected tab. Configure settings, review alerts, manage devices, set workflows, and more.',
      side: 'top' as const,
      align: 'start' as const,
    },
  },
];

export const siteRoutes: RouteConfig[] = [
  {
    id: 'sites',
    processName: ONBOARDING_KEYS.sites,
    match: (path: string) => path === '/sites',
    steps: sitesPageSteps,
  },
  {
    id: 'site-add-new',
    processName: ONBOARDING_KEYS.siteAddNew,
    match: (path: string) => path === '/site/new' || /^\/site\/new/.test(path),
    steps: addSiteSteps,
  },
  {
    id: 'site-detail',
    processName: ONBOARDING_KEYS.siteDetail,
    match: (path: string) =>
      /^\/[Cc]ustomer\/[^/]+\/project\/[^/]+$/.test(path) || /^\/site\/[^/]+$/.test(path),
    steps: siteDetailSteps,
  },
];
